module.exports = __webpack_public_path__ + "img/2-sm.1fb4a53b.jpg";